import { render } from "./HeaderNotification.vue?vue&type=template&id=01676a98"
import script from "./HeaderNotification.vue?vue&type=script&lang=js"
export * from "./HeaderNotification.vue?vue&type=script&lang=js"

import "./HeaderNotification.vue?vue&type=style&index=0&id=01676a98&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__